export default __webpack_public_path__ + "static/media/trusonaImg.597d7ac1.png";